/**
 * Convert objects to URL encoded query parameters
 */
export default function objectToQueryParams<T extends Record<string, unknown>>(
  obj: T
): string {
  return Object.entries(obj)
    .filter(([, value]) => !!value)
    .map(([key, value]) => `${key}=${encode(value)}`)
    .join('&')
}

function encode(o: unknown) {
  if (o) {
    try {
      return encodeURIComponent(JSON.stringify(o) || '')
    } catch (e) {
      console.error(e)
      return ''
    }
  }
}
